import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Home from "./Pages/home";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Pages/about";
import Topbar from "./Components/Topbar";
import Login from "./Pages/login";
import Contact from "./Pages/contact";
import Polyclinics from "./Pages/polyclinic";
import Gallery from "./Pages/gallery";
import Emas from "./Pages/emas";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Topbar />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/polyclinics" element={<Polyclinics />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/emas" element={<Emas />} />
    </Routes>
    <Footer />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
